module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent-top"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Taming CHAOS")]), _vm._v(" is an excellent and appealing way for students and families to learn about risk and making good decisions.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sonia Levitin")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Award Winning,")]), _vm._v(" German American Novelist, Young Adult Author and Holocaust Survivor")]), _vm._v(" "), _c('p', {
    staticClass: "indent-top"
  }, [_vm._v("“Gary Miller’s analysis of risk management is spot on. The book was written for teens, but it may interest college students too!”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("M. Moshe Porat")]), _vm._v(", Ph.D., CPCU, Dean, Fox School of Business, Temple University")]), _vm._v(" "), _c('p', {
    staticClass: "indent-top"
  }, [_vm._v("“Adolescence is the frontier during which children transition from dreamers to doers. Unlike adults; however, teens do not have the brain development necessary to create and stick to concrete decisions in their best interest. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Taming CHAOS")]), _vm._v(" provides young adult readers with a prescriptive decision-making tool that is woven into the fabric of this delightful novel about decision-making and managing risk to adopt a rescued dog. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Taming CHAOS")]), _vm._v(": charming, age-appropriate, relevant for young teens who struggle with decision-making at the onset of carving out their unique path in life.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jeannie Hofmann")]), _vm._v(", English Teacher, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Teacher of the Year,")]), _vm._v(" Upper Moreland High School, Montgomery County, PA")]), _vm._v(" "), _c('p', {
    staticClass: "indent-top"
  }, [_vm._v("“As a current Middle School Principal and former High School Math Teacher, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Taming CHAOS")]), _vm._v(" embraces all aspects of adolescent social, emotional, quantitative & analytical development throughout its highly enjoyable story. All School Districts should adopt this excellent thought provoking book into their Character Education & Math Curriculums!”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Adam Slavin")]), _vm._v(", Middle School Principal, Upper Merion Area School District, Montgomery County, PA")]), _vm._v(" "), _c('p', {
    staticClass: "indent-top"
  }, [_vm._v("“A Groundbreaking and Revolutionary Masterpiece that will engage and inspire entire families.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Michael Levin")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")]), _vm._v(" Best Selling Author")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 60
// module chunks = 0